export default {"src":"/_next/static/media/diLoader.cca74906.gif","height":256,"width":256,"blurWidth":0,"blurHeight":0};